module.exports = __webpack_public_path__ + "img/payment.60333be1.svg";